import React, { Component } from 'react';
import PageLayout from '../../layouts/pagelayout';
import SectionTitle from '../../components/section-title';
import Collapse from '../../components/collapse';
import { graphql, useStaticQuery, Link } from 'gatsby';
import CustomImage from '../../components/custom-image';
import BreadCrumb from '../../components/breadcrumb';
import ScrollPositionAnimation from '../../components/scrollpositionanimation';

const MessageFromChairman = () => {
  return (
    <PageLayout pageTitle="Vedanta - Anil Agarwal | Chairman" pageLink="/overview/messages-from/chairman">
      <div className="chairman-and-ceo-msg">
        <div className="msg-container">
          <div className="msg-inner">
            <BreadCrumb />
            <div className="section-inner">
              <ScrollPositionAnimation targetElement1="anim-one" targetElement2="anim-two">
                <div className="two-column">
                  <div className="left-img">
                    <div className="left-to-right anim-one">
                      <CustomImage imageName="chairman_page.png" alt="Message from Chairman" maxWidth="566" />
                    </div>
                  </div>
                  <div className="right-disc">
                    <div className="bottom-to-top anim-two">
                      <SectionTitle
                        label="Chairman’s statement"
                        lighttext="Enabling a "
                        boldtext="well-resourced future "
                      ></SectionTitle>
                      <p className="bold-text">Dear Stakeholders,</p>
                      <p>
                        It is a great honour for me to share my thoughts with you as your Company’s Chairman. This year,
                        the Board welcomed and appointed me as the Non-Executive Chairman of Vedanta Limited. The
                        Company will now be run by a guided Management Committee comprising of your Group CEO, CFO, CHRO
                        and CCO.
                      </p>
                      <Collapse labelOne="Read More" labelTwo="Read Less">
                        <p>
                          I sincerely wish and pray that you all are safe at your homes. Your safety matters to us, as
                          the world is currently grappling with an unprecedented health crisis that we all are fighting
                          together. These are undoubtedly testing times, but it also brings to the fore the undaunted
                          and ingenious human spirit that prevails against all challenges. We, at Vedanta, salute this
                          human spirit and solidarity of citizens and nations across the world, and reaffirm our
                          commitment to work towards a self-reliant and sustainable future for all.
                        </p>
                        <p>
                          India’s Covid response continues to be undoubtedly exemplary by global standards, and the
                          Government of India along with all state governments are coordinating effectively to flatten
                          the curve. We, at Vedanta, are doing our bit in a modest way to help save lives and
                          livelihoods. You will be happy to know that your Company has contributed ₹101 crores to the
                          Prime Minister's Citizen Assistance and Relief in Emergency Situations (PM-CARES) Fund. Your
                          Company will also fund up to ₹200 crores in providing relief measures to communities across
                          India. The contribution to PM-CARES Fund will complement Vedanta's earlier commitment of
                          creating a ₹100-crore corpus to cater to three specific areas -- livelihood of the daily wage
                          workers across the nation, preventive health care, support to its employees and contract
                          partners across its plant locations.
                        </p>
                      </Collapse>
                    </div>
                  </div>
                </div>
              </ScrollPositionAnimation>
            </div>
          </div>
        </div>
        <div className="msg-container">
          <div className="msg-inner">
            <div className="section-inner">
              <ScrollPositionAnimation targetElement1="anim-three" targetElement2="anim-four">
                <div className="two-column">
                  <div className="left-quote">
                    <div className="left-to-right anim-three">
                      <div className="quote-box">
                        <p>
                          "With ample natural, human and technological resources and strong reform-focused democratic
                          governance, India holds out hope that in the post-COVID era global businesses and investors
                          look at reducing dependency on China. This will mean more jobs, more investments, rapid
                          development and a great boost to the government’s ‘Make in India’ initiative."
                        </p>
                        <div className="person">Anil Agarwal</div>
                        <div className="desig">Chairman</div>
                      </div>
                    </div>
                  </div>
                  <div className="right-content">
                    <div className="bottom-to-top anim-four">
                      <h4 className="m-t-0">Performance during the year</h4>
                      <p>
                        As we have seen, the year was challenging, which tested our organisational mettle amidst a
                        turbulent macro environment. However, our Company emerged stronger at the end of it, paving
                        pathways for accelerated future growth.
                      </p>
                      <p>
                        The year saw us accomplishing robust production volumes in multiple segments and continued
                        building our asset base, while improving asset integrity. We have further strengthened the
                        company with strong operational and productivity focus, enhanced our capital allocation
                        framework to create long-term shareholder value and delivered a sound set of financial outcomes.
                      </p>
                      <p>
                        It is gratifying to note that we remained cashflow positive, while maintaining a resilient
                        balance sheet. Our work continued in an uninterrupted manner across all key result areas. As a
                        testimony to our efforts, we also received well-accredited recognitions across governance,
                        safety and environmental parameters, including moving up in the rankings of in the Dow Jones
                        Sustainability Index (DJSI).
                      </p>
                      <p className="m-b-0">
                        To summarise, it was a year where we could yet again validate the confidence vested in us by
                        everyone.
                      </p>
                      <h4>A gradual economic recovery</h4>
                      <p>
                        In CY 2019, the global economy seemed to be on a path to recovery. This was primarily led by the
                        bottoming out of manufacturing activity and global trade and monetary policy easing by central
                        banks the world over. This sentiment was further bolstered at the start of CY 2020, in light of
                        the progress in US-China trade talks and Brexit deal.
                      </p>
                      <p>
                        In what was expected to be a year of continued recovery, CY 2020 now has a fresh challenge to
                        combat in the form of the Covid-19 pandemic. Although it is early to ascertain its impact on
                        global supply chains, consumer behaviour, overall business sentiment and supply-demand equations
                        in the short term, we will have more clarity only over the medium-term.
                      </p>
                      <Collapse labelOne="Read More" labelTwo="Read Less">
                        <h4>A pro-growth, pro-business environment in India</h4>
                        <p>
                          For India, FY 2020 was characterized by several developments, including the re-election of the
                          ruling party with an even larger mandate; the systemic identification, restructuring and
                          tidying up of prevailing issues in the financial services sector; and the announcement of a
                          slew of policy measures by the government. While the clean-up applied temporary brakes on
                          growth owing to a credit crunch, the fiscal and monetary policy announcements acted as a
                          counterbalance, along with focus on keeping inflation under permissible limits.
                        </p>
                        <p>
                          At the juncture that we are in, India faces its own unique opportunities and the priorities
                          that come with it. As we stand today, we have the reasons to believe that we are better
                          positioned than any other nation with a visionary government, young working population, a
                          conducive business environment and rising public expenditure.
                        </p>
                        <p>
                          The government’s announcements made through the year and as part of the Union Budget 2020-21
                          are directed at setting the stage for India’s future growth. Among these, the National
                          Infrastructure Pipeline with a projected total investment of INR 102 lakh crore (USD 1.44
                          trillion) during the period FY 2020-2025 deserves a special mention. It reinforces the
                          government’s commitment to build an India of the future with better connectivity and better
                          resilience. It also has a direct and positive impact on heavy industries such as ours, with
                          expected short to medium term buoyancy in demand. Other measures, such as a corporate tax cut,
                          100% FDI in coal mining, and merger of public sector banks are also noteworthy, which are
                          directed at boosting the business climate in the country.
                        </p>
                        <CustomImage imageName="wind-power.png" alt="Harnessing Wind Power" maxWidth="756" />
                        <h4>Metals and mining – Propelling India’s Growth</h4>
                        <p className="m-b-0">
                          With large-scale infrastructure spend on the horizon, the metals and mining sector is expected
                          to receive a boost in demand both over the short as well as longer term. This growth will be
                          further facilitated by the National Mineral Policy 2019, launched to ensure transparency,
                          better regulation and enforcement, and to ensure a balance between social and economic growth.
                          The Policy touches upon contemporary issues and guides on the adoption of scientific mining,
                          technology and innovation, and environmental and social priorities As Vedanta, we are well
                          aligned to these guidelines and continue to set new benchmarks in good mining practices.
                        </p>
                        <h4>Vedanta - Ready to service the nation’s needs</h4>
                        <p className="m-b-0">
                          As India grows, so will its needs and aspirations. At Vedanta, we are focussed on providing
                          vital commodities that facilitate the everyday lives of Indians and service their needs.
                          Vedanta as India’s only diversified natural resources group is presented with a unique
                          opportunity to provide the vital commodities the country needs for infrastructure development,
                          asset creation, mobility, housing, consumer goods and general consumption. Together with
                          everyone, we can harness the potential of natural resources in the most sustainable way to
                          fuel the nation's progress. It is with this objective that we have reinforced our positioning
                          as ‘Vedanta, Desh ki Zarooraton ke liye.’
                        </p>
                        <h4>Contributing to nation-building </h4>
                        <p>
                          At Vedanta, our business performance contributes directly to the nation’s economy. With over
                          40% of revenue being contributed to the national exchequer, we continue to deliver on our
                          commitments, in the most transparent and ethical manner. We also employ closer to 80,000
                          on-roll and contractual personnel, thus creating a multiplier effect on the economy. According
                          to a recent report by Institute for Competitiveness, a subsidiary of IFC (part of the World
                          Bank Group), Vedanta’s operations contribute around ~1% to India’s GDP.
                        </p>
                        <p>
                          As we grow further, we continue to play a pivotal role in India’s social development stage,
                          and maintain a strong social engagement through our corporate responsibility initiatives. In
                          FY 2019-20, we spent ~US$41 million, to touch the lives of over 3.26 million people. Our core
                          impact areas are education, health, sustainable livelihoods, women empowerment, sports and
                          culture, environment and community development. Each of our Group companies have their own CSR
                          agenda and they undertake associated interventions in one or more of the above impact areas.
                          For example, Balco actively supports the fight against cancer through its 170-bed Medical
                          Centre in Chhattisgarh, under the aegis of Vedanta Medical Research Foundation.
                        </p>
                        <p>
                          Our flagship CSR programme, Nand Ghar, is aimed at building modern community resource centres
                          through the length and breadth of the nation. Conceived in association with the Ministry of
                          Women and Child Development (MoWCD), the Nand Ghar initiative targets the empowerment of 8.5
                          crore children and 2 crore women across 13.7 lakh Anganwadis in India. 2019 was a milestone
                          year for this initiative, as we witnessed the inauguration of our 1000th Nand Ghar. By FY
                          2020-21, we are planning to quadruple the number of these centres, with an unwavering
                          commitment to giving back to the society
                        </p>
                        <CustomImage imageName="awareness-building.png" alt="Awareness Building " maxWidth="756" />
                        <h4>A firm focus on environmental sustainability</h4>
                        <p>
                          Our sustainability approach is strongly driven by the need to address the expectations of our
                          stakeholders while delivering strong business performance. As a company we are attuned to
                          global expectations and endeavour to contribute to the fulfilment of the UN SDGs.
                        </p>
                        <p>
                          Our sustainable development agenda straddles four major pillars of Responsible Stewardship,
                          Building Strong Relationships, Adding and Sharing Value, and Strategic Communications. These
                          are developed in line with our core values, internal and external sustainability imperatives
                          and global relevant frameworks.
                        </p>
                        <p>
                          Our environmental, social and governance (ESG) priorities are well-aligned to our enterprise
                          goals and towards this end, we are working with a target-based approach to foster an inclusive
                          and sustainable future for all. We ensure the safety of our workforce with its associated
                          programs on Visible Felt Leadership, deeper engagement on safety with our Business Partners,
                          and managing critical safety tasks.
                        </p>
                        <p>
                          We are also managing our environmental impact through associated programs on GHG emissions
                          intensity reduction, tailings dam management, and recycling of our high-volume-low-effect
                          wastes such as fly ash. We have defined a social performance framework for the organization to
                          secure our social license to operate assessing the maturity of our business in the context,
                          and driving community development activities across multiple spheres such as child education,
                          women’s empowerment, medical infrastructure development, and sports, among others.
                        </p>
                        <CustomImage imageName="teamwork-banner.png" alt="team work" maxWidth="756" />
                        <h4>Employee safety, health and wellbeing</h4>
                        <p className="m-b-0">
                          The safety, health and wellbeing of our employees continue to be a highly critical focus area
                          for us. However, I regret to inform that even with a razor-sharp focus on occupational health
                          and safety, we witnessed seven fatalities this year. One life lost is too many for us, and we
                          have redoubled our efforts to effectively enforce a safety culture and avoid any untoward
                          incident, going forward.
                        </p>
                        <h4>Together we win</h4>
                        <p>
                          Ever since we began our journey, our culture has always been people-centric, because we
                          believe we are only as resourceful, resilient and future ready as our people. We are committed
                          to provide our people a safer, sustainable, inspiring and inclusive culture.
                        </p>
                        <p className="m-b-0">
                          Our culture enshrines our core values and nurtures innovation, creativity and diversity. We
                          align our business goals with individual goals and enable our employees to grow on the
                          personal as well as the professional front. Being an equal opportunity employer, and a
                          meritocracy – all our decisions regarding employees are based on their contribution, attitude
                          and potential.
                        </p>
                        <h4>Changes in leadership</h4>
                        <p>
                          With a heavy heart, I would like to announce that Srinivasan Venkatakrishnan (Venkat) stepped
                          down as the CEO and Director of the Company with effect from 5th April 2020, for personal
                          reasons and will be re-joining his family in South Africa. Over the last 2 years, I have
                          enjoyed working with Venkat to drive our vision for the company and the country at large.
                        </p>
                        <p>
                          I admire Venkat for his passion, dedication, ability to connect with people and his grasp of
                          business. Venkat is a committed leader and will be remembered for his passion for
                          sustainability, asset integrity, development and positioning Vedanta in global markets. We
                          would like to acknowledge and express our deep appreciation and gratitude to Venkat for his
                          immense contribution to the Company. This year, we also had to bid adieu to Ajay Kumar Dixit,
                          our Cairn Oil & Gas business CEO and Deshnee Naidoo, our Zinc International business CEO. Ajay
                          superannuated from the Company at the end of his five-year term this May, while Deshnee had to
                          leave us for personal reasons. Both led respective businesses with great zeal and passion.
                        </p>
                        <p className="m-b-0">
                          We wish them the best for all their upcoming endeavours. It is my pleasure to welcome Sunil
                          Duggal- as our interim CEO, a mature and proven leader who has held key leadership positions
                          across the Group in the last 10 years. Sunil is an industry veteran and an active member of
                          several industry and advocacy forums. He is passionate about safety, environment and ESG. We
                          look forward to Sunil taking the Company to greater heights. I also want to place on record my
                          thanks to the 80,000+ people who make up the Vedanta family and who, during this year, have
                          innovated, broken records, and driven up our output with ever-increasing efficiency.
                        </p>
                        <h4>Way forward</h4>
                        <p>
                          I sincerely believe that the post-Covid world will bring huge opportunities for India to
                          secure a better place in the emerging global economic order. I also believe the ultimate ‘Make
                          in India’ moment for our country is soon to arrive. With ample natural, human and
                          technological resources and strong reform-focused democratic governance, India holds out hope
                          in the post-Covid era as global businesses and investors look at reducing dependency on China.
                          This will mean more jobs, more investments, rapid development and a great boost to our ‘Make
                          in India’ initiative.
                        </p>
                        <p>
                          As I look back at Vedanta’s journey so far, I can say with reasonable confidence that we have
                          steadily grown and evolved to be an organisation creating disproportionate value for citizens
                          of India. Even amidst a short-term environment of uncertainty, I have well-founded belief in
                          our fundamentals, our strategy and our people, which taken together, is a powerful force to
                          reckon with. My outlook remains positive for the country and for the company and we are
                          equipped to fulfil every commitment we have towards our stakeholders.
                        </p>
                        <p>
                          On behalf of the Board and the entire leadership team, I solicit your continued cooperation
                          for all our present and future endeavours.
                        </p>
                      </Collapse>
                    </div>
                  </div>
                </div>
              </ScrollPositionAnimation>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default MessageFromChairman;
